import { Action } from '@ngrx/store';
import { EditWithdrawTransaction } from '../../../transactions/transactions.types';

export enum EditTransactionFormActions {
    successEditTransactionForm = '[EditTransactionForm] Success',
    failEditTransactionForm = '[EditTransactionForm] Fail',
    submitEditTransactionForm = '[EditTransactionForm] Submit',
    openEditTransactionModalAction = '[EditTransactionForm] OpenModal'
}

export class SuccessEditTransactionForm implements Action {
    readonly type: string = EditTransactionFormActions.successEditTransactionForm;
}

export class FailEditTransactionForm implements Action {
    readonly type: string = EditTransactionFormActions.failEditTransactionForm;
}

export class SubmitEditTransactionForm implements Action {
    readonly type: string = EditTransactionFormActions.submitEditTransactionForm;

    constructor(public payload: EditWithdrawTransaction) {
    }
}

export class OpenEditTransactionModalAction implements Action {
    readonly type: string = EditTransactionFormActions.openEditTransactionModalAction;

    constructor(public transactionId: string) {
    }
}

export type EditTransactionFormSubmitAction =
    | SuccessEditTransactionForm
    | FailEditTransactionForm
    | SubmitEditTransactionForm
    | OpenEditTransactionModalAction;
